import {
  Backdrop,
  Pagination,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import React, { useEffect } from "react";
import { db } from "../services/firebase";
import { collection, getDocs } from "firebase/firestore";
import BackdropComponent from "../components/CargaComponents/BackdropComponent";
import { formatTimestamp, formatTimestampOtp } from "../constants/Functions";
import { useTittleContenidoStore } from "../context/tittleContenidoStore";

const SociosRegistrados = () => {
  const { setTittleContenido }: any = useTittleContenidoStore();
  const [search, setSearch] = React.useState("");
  const [socios, setSocios] = React.useState<any[]>([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 9; // Número de socios por página

  // Obtener socios registrados de Firestore
  const obtenerSocios = async () => {
    setIsLoading(true);
    try {
      const sociosSnapshot = await getDocs(collection(db, "users"));
      const sociosList = sociosSnapshot.docs.map((doc) => doc.data());
      setSocios(sociosList);
    } catch (error) {
      console.error("Error al obtener socios:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setTittleContenido("Socios Registrados");
    obtenerSocios();
  }, []);

  // Filtrar socios por nombre, DNI o correo
  const filteredSocios = socios.filter((socio) => {
    const nombre = socio.nombreSocio?.toLowerCase() || "";
    const dni = socio.dni?.toString() || "";
    const correo = socio.email?.toLowerCase() || "";
    return (
      nombre.includes(search.toLowerCase()) ||
      dni.includes(search) ||
      correo.includes(search.toLowerCase())
    );
  });

  // Calcular el número de páginas
  const pageCount = Math.ceil(filteredSocios.length / itemsPerPage);

  // Obtener socios de la página actual
  const displayedSocios = filteredSocios.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Cambiar la página
  const handlePageChange = (event: any, value: any) => {
    setCurrentPage(value);
  };

  return (
    <div>
      {isLoading && <BackdropComponent enabled={isLoading} />}
      <div className="d-flex justify-content-center h-100 mb-5">
        <TextField
          label="Buscar por DNI o Nombre"
          variant="outlined"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-25"
        />
        {/* Numero de socios registrados */}
        <h3 className="text-center mt-3 text-secondary fw-bold ms-5">
          Socios Registrados: {filteredSocios.length}
        </h3>
      </div>

      {/* Tabla de socios */}
      <div style={{ overflowX: "auto" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
                DNI
              </TableCell>
              <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
                Apellidos y Nombres
              </TableCell>
              <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
                Correo electrónico
              </TableCell>
              <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
                Nro. Celular
              </TableCell>
              <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
                Agencia
              </TableCell>
              <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
                Fecha de Afiliación
              </TableCell>
              <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
                Fecha de Registro
              </TableCell>
              <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
                Estado
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayedSocios.map((socio) => (
              <TableRow key={socio.dni}>
                <TableCell>{socio.dni}</TableCell>
                <TableCell>{socio.nombreSocio}</TableCell>
                <TableCell>{socio.correo}</TableCell>
                <TableCell>{socio.nroTelefono}</TableCell>
                <TableCell>{socio.agencia}</TableCell>
                <TableCell>
                  {formatTimestampOtp(socio.fechaAfiliacion)}
                </TableCell>
                <TableCell>{formatTimestampOtp(socio.dateRegister)}</TableCell>
                <TableCell>
                  {socio.isblocked ? "Bloqueado" : "Activo"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      {/* Paginación */}
      <Stack spacing={2} alignItems="center" marginY={2}>
        <Pagination
          count={pageCount}
          page={currentPage}
          onChange={handlePageChange}
          color="primary"
        />
      </Stack>
    </div>
  );
};

export default SociosRegistrados;
